<template>
    <div class="recommended-posts" v-if="posts.length">

        <div class="position-relative">
            <div class="row">
                <div class="col-12 col-lg-4" v-for="post in posts">
                    <recommended-posts-item :post="post"></recommended-posts-item>
                </div>
            </div>
            <div class="d-none d-lg-block horizontal-split-decor" v-if="posts.length > 3"></div>
        </div>

    </div>
</template>

<script>
import RecommendedPostsItem from "./RecommendedPostsItem";

export default {
    name: "RecommendedPosts",
    components: { RecommendedPostsItem },
    props: {
        posts: {
            type: Object,
            default: []
        }
    }
}
</script>

<style scoped>
    .recommended-posts {

    }

    .horizontal-split-decor{
        position: absolute;
        width: 100%;
        height: 1px;
        background: #E8E8E8;
        top: 50%;
        transform: translateY(-50%);
    }
</style>